import clsx from 'clsx'
import React, { FunctionComponent } from 'react'

import { ColorTypes, getColorVariable } from '../foundation/Colors'
import { Icon } from '../Icon'
import { AllIconNames, IconColors, IconSizes } from '../Icon/BaseIcon'
import { useThemeClass } from '../Theme'
import { ICON_SIZE_MAP, SIZES } from './constants'
import styles from './style.module.scss'

type SizesType = typeof SIZES
type SizesKeys = keyof SizesType
export type IconAvatarSizes = SizesType[SizesKeys]

export interface IconAvatarProps {
  iconName: AllIconNames
  backgroundColor: ColorTypes
  iconColor?: IconColors
  size?: IconAvatarSizes
  title?: string
  testNameSpace?: string
}

export type IconAvatarComponent = FunctionComponent<IconAvatarProps>

export const IconAvatar: IconAvatarComponent = ({ iconName, backgroundColor, iconColor = 'Inverse', size = SIZES.M, title, testNameSpace = '' }) => {
  const themeClass = useThemeClass()
  const bgColor = getColorVariable(backgroundColor)
  const iconSize: IconSizes = ICON_SIZE_MAP[size]
  const containerClasses = clsx(styles.container, styles[`size${size}`], styles[themeClass])
  const hasTestId = testNameSpace.length > 0

  return (
    <span className={containerClasses} style={{ backgroundColor: bgColor }} {...(hasTestId && { 'data-testid': testNameSpace })}>
      <Icon name={iconName} color={iconColor} size={iconSize} title={title} />
    </span>
  )
}
